import { BaseSuggestion } from '@easy-expense/data-schema-v2';
import { deletedUsageSubHeader } from '@easy-expense/frontend-data-layer';
import { IconName } from '@easy-expense/ui-shared-components';

import { AutoCompleteValue } from './Dropdown/AutoCompleteTypes';

/**
 * Deleted suggestions, rendered as dropdown options that say how much history still depends on
 * them. They go at the end of a dropdown's options, after everything still selectable.
 */
export const deletedAutoCompleteValues = <E extends BaseSuggestion>(
  deleted: { entity: E; usageCount: number }[],
  iconicIcon?: IconName,
): AutoCompleteValue[] => {
  return deleted.map(({ entity, usageCount }) => ({
    key: entity.key,
    value: {
      ...entity.value,
      name: `${entity.value.name} · ${deletedUsageSubHeader(usageCount)}`,
      iconicIcon: iconicIcon ?? null,
    },
  }));
};
